// import Vue from 'vue'
import getAwesomeSwiper from 'vue-awesome-swiper/dist/exporter'
import { Swiper as SwiperClass, Lazy, Navigation } from 'swiper/core'

import 'swiper/swiper-bundle.css'

SwiperClass.use([Lazy, Navigation])

const AwesomeSwiper = getAwesomeSwiper(SwiperClass)

// Vue.use(AwesomeSwiper)
const { Swiper, SwiperSlide } = AwesomeSwiper

export default {
  components: {
    Swiper,
    SwiperSlide,
  },
  data() {
    return {
      cardSwiperConfig: {
        slidesPerView: 1,
        lazy: true,
        preloadImages: false,
        navigation: {
          nextEl: '[data-next]',
          prevEl: '[data-prev]',
        },
        loop: true,
      },
      similarSwiperConfig: {
        slidesPerView: 'auto',
        speed: 800,
        touchStartPreventDefault: false, // required for correct work of cursor animations
        breakpoints: {
          640: {
            spaceBetween: 16,
          },
          1200: {
            spaceBetween: 16,
            slidesOffsetBefore: 16,
          },
        },
      },
      detailSwiperConfig: {
        slidesPerView: 'auto',
        lazy: {
          loadPrevNext: true,
          loadPrevNextAmount: 4,
        },
        preloadImages: false,
        navigation: {
          nextEl: '[data-next]',
          prevEl: '[data-prev]',
        },
        speed: 800,
        spaceBetween: 0,
        slidesOffsetBefore: 0,
        breakpoints: {
          640: {
            slidesOffsetBefore: 16,
            spaceBetween: 16,
          },
          1200: {
            slidesOffsetBefore: 32,
            spaceBetween: 32,
          },
          1440: {
            slidesOffsetBefore: 32,
            spaceBetween: 32,
          },
        },
      },
      gallerySwiperConfig: {
        slidesPerView: 'auto',
        loop: true,
        lazy: {
          loadPrevNext: true,
        },
        preloadImages: false,
        navigation: {
          nextEl: '[data-next]',
          prevEl: '[data-prev]',
        },
        speed: 800,
        spaceBetween: 16,
        breakpoints: {
          1200: {
            spaceBetween: 32,
          },
        },
        centeredSlides: true,
        keyboard: {
          enabled: true,
        },
      },
    }
  },
}
